import React from 'react';

export default function TicketPrices({
  prices,
  has_ticket_prices,
  is_ymc_only,
  is_members_only,
  is_free_event,
  user,
}) {
  const is_any_member = user?.is_any_member ?? false;

  if (is_ymc_only) {
    return (
      <p>
        {is_any_member
          ? 'THIS EVENT IS RESTRICTED TO GUESTS UNDER THE AGE OF 40'
          : 'THIS EVENT IS RESTRICTED TO YMC MEMBERS AND GUESTS UNDER THE AGE OF 40'}
      </p>
    );
  }

  if (is_members_only && !is_any_member) {
    return <p>Only members may register for this event.</p>;
  }

  if (is_free_event) {
    return <p>This is a free event.</p>;
  }

  if (!has_ticket_prices) {
    return (
      <p>
        {prices?.no_tickets_message || 'No ticket prices have been listed for this event.'}
      </p>
    );
  }

  const additional = prices?.additional ?? [];

  return (
    <ul className="ticket-prices list-style-none m-0 p-0 has-small-font-size has-arquitecta-font-family">
      {prices?.member != null && (
        <li>
          <span className="label">Members</span>
          <span className="cost">${prices.member}</span>
        </li>
      )}
      {prices?.young_member != null && (
        <li>
          <span className="label">Young Members Circle</span>
          <span className="cost">${prices.young_member}</span>
        </li>
      )}
      {additional.map((ticket, i) => (
        <li key={i}>
          <span className="label">{ticket.label}</span>
          <span className="cost">${ticket.price}</span>
        </li>
      ))}
      {prices?.non_member != null && (
        <li>
          Non-Member
          <span className="cost">${prices.non_member}</span>
        </li>
      )}
    </ul>
  );
}
